import { StringWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-date-widget',
  templateUrl: './date.widget.html'
})
export class MyDateWidgetComponent extends StringWidget {

}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/date/date.widget.ts